<div class="col-md-auto">
    @if (showAbort) {
    <p>
        <button class="btn btn-danger btn-lg" type="button" (click)="cancel()">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            &nbsp;
            <span i18n>Cancel submission</span>
        </button>
    </p>
    <div class="alert alert-warning" i18n>
        Do not close or leave this page until the submission is sent.
    </div>
    }
    @else {
    <p>
        <button class="btn btn-primary btn-lg" (click)="startCountdown()">
            <fa-icon [icon]="faPaperPlane" aria-hidden="true"></fa-icon>
            &nbsp;
            <span i18n>Confirm submission!</span>
        </button>
    </p>
    }
</div>
